import { render, staticRenderFns } from "./EnrollmentOrderEdit.vue?vue&type=template&id=656c88be&"
import script from "./EnrollmentOrderEdit.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentOrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports